import { TicketSlice } from '../slice'
import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const TicketActions = {
  ...TicketSlice.actions,
  getData,
  getBulkData,
}
